const storePath="/";
const cartPath="/cart"
const addproduct="/addproduct"
export const isStoreSelected=(currentPath)=>currentPath ===storePath;
export const isCartSelected=(currentPath)=>currentPath ===cartPath;
export const isAddProduct=(currentPath)=>currentPath ===addproduct;
